/**
 * Role names. On the backend ADMIN is ROLE_ADMIN for reference.
 */
const role = {
  ADMIN: 'admin',
  AREA_LEAD: 'area-lead',
  BARISTA: 'barista',
  DIRECTOR: 'director',
  EXECUTIVE: 'executive',
  HOME_OFFICE: 'home-office',
  HOURLY: 'hourly',
  MANAGER: 'manager',
  OWNER: 'owner',
  SALARY: 'salary',
  STORE_LEAD: 'store-lead',
} as const

export type RoleName = (typeof role)[keyof typeof role]

export default role
